import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function TermsOfServicePage() {
  const lastUpdated = 'April 2, 2026';
  return <div className="bg-viridia-black min-h-screen pt-32 pb-24" data-id="element-2901" data-mp="14xg03ypigpyp">
      <SEOHead title="Terms of Service | Viridia Analytics" description="Terms of Service for Viridia Analytics. Review the terms governing our marketing services." canonical="/terms" data-id="element-2902" data-mp="14ztus6ga405q" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2903" data-mp="r6kq2j3a02tj">
        <ScrollReveal data-id="element-2904" data-mp="r59kqeu6mn0b">
          <div className="text-center mb-16" data-id="element-2905" data-mp="r4rf4rlmqwfq">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-2906" data-mp="m8j4nridnrew">
              Terms of Service
            </h1>
            <p className="text-gray-400" data-id="element-2907" data-mp="ha7utgs31gwo">Last Updated: {lastUpdated}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-2908" data-mp="d8w1b0638bj7">
          <div className="bg-viridia-surface border border-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none" data-id="element-2909" data-mp="876rfnulq3wp">
            <div className="space-y-8 text-gray-300 leading-relaxed" data-id="element-2910" data-mp="7uyxxmptp7px">
              <section data-id="element-2911" data-mp="cn9zsv44j3l4">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2912" data-mp="cns2oalakg20">
                  1. Acceptance of Terms
                </h2>
                <p data-id="element-2913" data-mp="3v2ki3gal68sv">
                  By accessing our website or engaging Viridia Analytics ("we,"
                  "our," or "us") for services, you agree to be bound by these
                  Terms of Service. If you do not agree to these terms, please
                  do not use our services or website.
                </p>
              </section>

              <section data-id="element-2914" data-mp="hmmjx83m1wk0">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2915" data-mp="hlbivg1jv2wl">
                  2. Description of Services
                </h2>
                <p data-id="element-2916" data-mp="mmr53bfgrfgk">
                  Viridia Analytics provides digital marketing services,
                  including but not limited to ad campaign management (Google,
                  Meta, Yelp), marketing automation setup, CRM integration, and
                  web design/SEO services. The specific scope of services will
                  be outlined in a separate agreement or proposal provided to
                  the client.
                </p>
              </section>

              <section data-id="element-2917" data-mp="1330xsww6mm27">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2918" data-mp="z3ici00g88yu">
                  3. SMS/Text Messaging Terms
                </h2>
                <p className="mb-2" data-id="element-2919" data-mp="u5gu7haukdof">
                  By opting in to receive SMS communications from us, you agree
                  to the following:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2920" data-mp="k5zoizvlhzsg">
                  <li data-id="element-2921" data-mp="k6j96ocmr2a6">
                    By providing your phone number and submitting a form or
                    booking request, you consent to receive automated SMS/text
                    messages from Viridia Analytics.
                  </li>
                  <li data-id="element-2922" data-mp="2aiffyexdr0pq">
                    Messages may include appointment confirmations, reminders,
                    follow-ups, service updates, and promotional content.
                  </li>
                  <li data-id="element-2923" data-mp="197naz1uzlfj">
                    Message frequency varies. Message and data rates may apply.
                  </li>
                  <li data-id="element-2924" data-mp="620uruopp7vb">
                    You may opt out at any time by replying{' '}
                    <strong data-id="element-2925" data-mp="a19nqxbxh1pt">STOP</strong>. Reply <strong data-id="element-2926" data-mp="a1ja8axrkqqr">HELP</strong> for help.
                  </li>
                  <li data-id="element-2927" data-mp="39ire1b9b1hey">
                    Opting out of SMS does not cancel any service agreement you
                    may have with us.
                  </li>
                  <li data-id="element-2928" data-mp="3iie450wl30sp">
                    We are not responsible for charges from your mobile carrier.
                  </li>
                  <li data-id="element-2929" data-mp="3nia8505a6s89">
                    SMS consent is not required as a condition of purchasing any
                    service.
                  </li>
                  <li data-id="element-2930" data-mp="12r00p31tpxkc">
                    Carriers are not liable for delayed or undelivered messages.
                  </li>
                </ul>
              </section>

              <section data-id="element-2931" data-mp="11a32fr1bbqi5">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2932" data-mp="11bnth6of4rb9">
                  4. Client Responsibilities
                </h2>
                <p className="mb-2" data-id="element-2933" data-mp="1aareig75bgse">
                  To ensure the successful delivery of our services, you agree
                  to:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2934" data-mp="16ba9tozjmnoa">
                  <li data-id="element-2935" data-mp="1k7dzd4zh27uf">
                    Provide timely access to necessary accounts, assets, and
                    information required for campaign execution.
                  </li>
                  <li data-id="element-2936" data-mp="1txgp8wbar5oj">
                    Ensure that any materials provided to us do not infringe on
                    third-party intellectual property rights.
                  </li>
                  <li data-id="element-2937" data-mp="22yewroky1vbv">
                    Comply with the terms and policies of third-party
                    advertising platforms (e.g., Google, Meta, Yelp).
                  </li>
                  <li data-id="element-2938" data-mp="2hm58vzbv1323">
                    Review and approve campaigns or materials in a timely manner
                    when requested.
                  </li>
                </ul>
              </section>

              <section data-id="element-2939" data-mp="28lqjanrv51ss">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2940" data-mp="28kfeckmolo03">
                  5. Payment Terms
                </h2>
                <p data-id="element-2941" data-mp="2ckze7vyn35px">
                  Fees for our services are outlined in your specific service
                  agreement. Unless otherwise stated, invoices are due upon
                  receipt. We reserve the right to pause or suspend services if
                  payment is not received within the agreed-upon timeframe. Ad
                  spend (payments made directly to platforms like Google or
                  Meta) is separate from our management fees and is the sole
                  responsibility of the client.
                </p>
              </section>

              <section data-id="element-2942" data-mp="1kube8n8pc6du">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2943" data-mp="1kxpenpxt25in">
                  6. Intellectual Property
                </h2>
                <p data-id="element-2944" data-mp="3hubvvidmuadk">
                  Upon full payment for services rendered, clients retain
                  ownership of the final deliverables (e.g., website design, ad
                  copy) created specifically for them. Viridia Analytics retains
                  ownership of any proprietary tools, methodologies, or
                  pre-existing materials used in the delivery of services.
                </p>
              </section>

              <section data-id="element-2945" data-mp="4fp2ndbu9bxe">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2946" data-mp="4d2y7mk8vcje">
                  7. Limitation of Liability
                </h2>
                <p data-id="element-2947" data-mp="3rkenpf90piab">
                  While we strive to deliver the best possible results, Viridia
                  Analytics does not guarantee specific outcomes, such as a
                  certain number of leads or revenue, as these depend on various
                  market factors. In no event shall Viridia Analytics be liable
                  for any indirect, incidental, special, or consequential
                  damages arising out of or in connection with our services.
                </p>
              </section>

              <section data-id="element-2948" data-mp="14mkgeh1ecjad">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2949" data-mp="14l99w9gkgxfk">
                  8. Termination
                </h2>
                <p data-id="element-2950" data-mp="1ed5kul3r4i17">
                  Either party may terminate the service agreement with written
                  notice as specified in the individual contract. Upon
                  termination, the client is responsible for payment for all
                  services rendered up to the termination date.
                </p>
              </section>

              <section data-id="element-2951" data-mp="1sceqiqubztqx">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2952" data-mp="1sau45oi67h45">
                  9. Governing Law
                </h2>
                <p data-id="element-2953" data-mp="3u41k905ly2r3">
                  These Terms of Service shall be governed by and construed in
                  accordance with the laws of the State of Arizona, without
                  regard to its conflict of law provisions. Any legal action or
                  proceeding arising under these terms shall be brought
                  exclusively in the courts located in Phoenix, Arizona.
                </p>
              </section>

              <section data-id="element-2954" data-mp="3g02ojpf5z0rb">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2955" data-mp="3g0vuio6atm8e">
                  10. Contact Information
                </h2>
                <p className="mb-2" data-id="element-2956" data-mp="2nadjn0zc2gkf">
                  If you have any questions about these Terms of Service, please
                  contact us:
                </p>
                <ul className="list-none space-y-1" data-id="element-2957" data-mp="317sdqj0j7ciq">
                  <li data-id="element-2958" data-mp="2w9qu9wz71b6q">
                    <strong data-id="element-2959" data-mp="2w98r0ge45wpb">Company:</strong> Viridia Analytics
                  </li>
                  <li data-id="element-2960" data-mp="gicqtz4fo7yd">
                    <strong data-id="element-2961" data-mp="ght9okmlxnle">Location:</strong> Phoenix, AZ
                  </li>
                  <li data-id="element-2962" data-mp="bjrpfwdg3i8c">
                    <strong data-id="element-2963" data-mp="bmno5mx4aaxu">Email:</strong>{' '}
                    <a href="mailto:info@viridiaanalytics.com" className="text-viridia hover:underline" data-id="element-2964" data-mp="k1bv0hwz1k9m">
                      info@viridiaanalytics.com
                    </a>
                  </li>
                  <li data-id="element-2965" data-mp="a5qoc6gyjvtj">
                    <strong data-id="element-2966" data-mp="f1ywv10ngqrq">Phone:</strong>{' '}
                    <a href="tel:6233000708" className="text-viridia hover:underline" data-id="element-2967" data-mp="f2qu0g9wawk4">
                      (623) 300-0708
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>;
}